import { LinkReference } from './link-reference';

export class Link {
    public browser?: string;
    public inApp?: string;
    public nec?: string;
    public web?: Link;
    public webapp?: Link;
    public references?: LinkReference[];

    public constructor(init?: Partial<Link>) {
        Object.assign(this, init);
    }
}
